import axios from 'axios';

import { useServicerStore } from '../store';

const LenderService = {
  async createLender(formValues) {
    const response = await axios.post('/lender', {
      ...formValues,
      servicer_id: useServicerStore.getState()?.servicerId,
    });

    return response.data;
  },

  async updateLender({ lenderId, formValues }) {
    const response = await axios.patch(`/lender/${lenderId}`, {
      ...formValues,
      servicer_id: useServicerStore.getState()?.servicerId,
    });

    return response.data;
  },

  async getLender(lenderId) {
    const response = await axios.get(`/lender/${lenderId}`);

    return response.data;
  },

  async getLenders() {
    const response = await axios.get('/lender', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
      },
    });

    return response.data;
  },

  async getLenderLoans({ lenderId, page, limit }) {
    const response = await axios.get(`/lender/${lenderId}/loan`, {
      params: {
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async getLenderLoansForLender({ lenderId, page, limit }) {
    const response = await axios.get(`/lender/${lenderId}/loans`, {
      params: {
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async getLenderDistributions({ lenderId, page, limit }) {
    const response = await axios.get(`/lender/${lenderId}/distribution`, {
      params: {
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async getLenderBillPayments({ lenderId, page, limit }) {
    const response = await axios.get(`/lender/${lenderId}/bill_payment`, {
      params: {
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async getLenderInsurances(lenderId) {
    const response = await axios.get(`/lender/${lenderId}/insurances`);

    return response.data;
  },

  async getLenderInsurancesPaginated({ lenderId, page, limit }) {
    const response = await axios.get(`/lender/${lenderId}/insurances`, {
      params: {
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async getLenderOpenBillPayments(lenderId) {
    const response = await axios.get(`/lender/${lenderId}/open_bill_payments`);

    return response.data;
  },

  async getLenderUsers(lenderId) {
    const response = await axios.get(`/lender/${lenderId}/users`);

    return response.data;
  },

  async getLenderBankAccounts(lenderId) {
    const response = await axios.get(`/lender/${lenderId}/bank_account`);

    return response.data;
  },

  async getLenderLienHolders(lenderId) {
    const response = await axios.get(`/lender/${lenderId}/lien_holder`);

    return response.data;
  },

  async getLenderContacts(lenderId) {
    const response = await axios.get(`/lender/${lenderId}/lender_contact`);

    return response.data;
  },

  async getLenderLoanGroups(lenderId) {
    const response = await axios.get(`/lender/${lenderId}/loan_group`);

    return response.data;
  },

  async getLenderDocuments(lenderId) {
    const response = await axios.get(`/lender/${lenderId}/document`);

    return response.data;
  },
};

export default LenderService;
